var MyLocalButlerPage = (function () {
  // Private methods
  var checkRedirect = function () {
    var petbutler = Cookies.getJSON('petbutler');
    if (typeof petbutler.user.closest_franchise.url !== 'undefined') {
      window.location.href = petbutler.user.closest_franchise.url;
    }
  };

  // Public methods
  return {
    checkRedirect: checkRedirect
  };
})();
